export default "__VITE_ASSET__CYycyMpt__"